import React from "react";
import Icon from "./Icon";
import Colors from "../../Colors";

export default class BranchConnectionRep extends Icon {

    static propTypes = Icon.propTypes;

    static defaultProps ={
        viewBox:"0 0 42 42"
    };

    get paths() {

        return (
            <>
                <path
                    fill={"none"}
                    d="M 1.1020242e-7,0 H 42 c 0,0 0,0 0,0 v 42 c 0,0 0,0 0,0 H 1.1020242e-7 C 4.915028e-8,42 0,42 0,42 V 0 c 0,0 4.915028e-8,0 1.1020242e-7,0 z"
                    id="rect156"/>
                <path
                    fill={this.props.color}
                    id="path89"
                    d="m 17.00204,28.39006 c -1.637691,-0.22151 -3.238222,-1.08947 -4.450809,-2.41365 -0.747482,-0.96561 -1.411819,-1.96302 -1.694707,-3.11442 -1.9922658,0 -3.9845317,0 -5.9767975,0 0,-1.25538 0,-2.51077 0,-3.76615 1.9883505,0 3.976701,0 5.9650515,0 0.369375,-1.34193 1.206058,-2.57431 1.978671,-3.36931 1.035758,-1.05179 2.074346,-1.66622 3.388028,-2.00435 0.938997,-0.2417 2.619092,-0.23807 3.66069,0.008 2.905768,1.21982 4.499017,2.78443 5.425076,5.36547 1.981856,0 3.963711,0 5.945567,0 v 3.76615 c -1.988349,0 -3.976698,0 -5.965047,0 -0.633849,1.86053 -2.079468,3.80698 -3.642585,4.67791 -1.44779,0.76628 -3.062687,1.0626 -4.633135,0.85018 z m 2.684706,-4.00554 c 2.871248,-1.43479 2.847833,-5.40746 -0.04025,-6.82927 -2.218866,-0.91327 -4.277325,0.28422 -5.065122,1.93511 -0.591425,1.40241 -0.149753,3.08958 0.740625,4.09161 0.724946,0.80243 1.541492,1.13763 2.808748,1.15297 0.707586,0.009 0.944183,-0.0447 1.556004,-0.35042 z m 11.400622,-9.3787 c 2.06065,2.02958 4.280275,4.22124 6.032905,5.9519 -2.010972,2.01205 -4.021939,4.02411 -6.032905,6.03617 z"
                />
            </>
        );
    }
}